<template>
  <div>
    <common-dialog
      ref="dialog"
      width="700px"
      show-save-button
      unit="考勤异常"
      id-key="AttendanceDtsId"
      :data="data"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="data.HandleStatus==0?api.handleV2:api.update"
      :get-data-func="api.info"
      :before-save="onBeforeSave"
      @edit-opened="onEditOpened"
      @close-saved="$emit('close-saved')"
      @create-opened="onCreateOpened"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24" v-if="data.HandleStatus==0">
            <el-form-item label="班主任补请假" class="longLabel is-required">
              <el-radio-group v-model="data.HandleType" @change="typeChange" style="margin-left: 10px;">
                <el-radio label="病假"></el-radio>
                <el-radio label="事假"></el-radio>
                <el-radio label="公假"></el-radio>
                <el-radio label="走读"></el-radio>
                <el-radio label="校本课程"></el-radio>
                <el-radio label="校内其他"></el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="data.HandleStatus==0||(data.HandleStatus==1&&now>-1&&now<6)">
            <el-form-item label="备注" class="longLabel">
              <el-input size="mini" :disabled="now==-1||now>5" type="textarea" v-model="tip1" placeholder="请填写备注"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="data.HandleStatus==0">
            <el-form-item label="其他处理" class="is-required" :class="isMB?'':'longLabel'">
              <el-radio-group v-model="data.HandleType" @change="typeChange" style="margin-left: 10px;">
                <el-radio label="医务室"></el-radio>
                <el-radio label="心理站"></el-radio>
                <el-radio label="迟到"></el-radio>
                <el-radio label="无故缺勤"></el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="data.HandleStatus==0||(data.HandleStatus==1&&now>5)">
            <el-form-item label="具体情况" class="longLabel">
              <el-input size="mini" :disabled="now<6" type="textarea" v-model="tip2" placeholder="请填写具体情况"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="data.HandleStatus==1">
            <el-form-item label="处理结果" class="longLabel">
              <el-tag type="success" size="small" v-if="data.HandleType=='病假'||data.HandleType=='事假'||data.HandleType=='公假'||data.HandleType=='校内其他'||data.HandleType=='走读'||data.HandleType=='校本课程'">{{data.HandleType}}</el-tag>
              <el-tag type="danger" size="small" v-else-if="data.HandleType=='医务室'||data.HandleType=='心理站'||data.HandleType=='迟到'||data.HandleType=='无故缺勤'">{{data.HandleType}}</el-tag>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <!-- <template slot="footer" v-if="handeled">
        <slot name="footer">
          <el-button size="small" @click="close">关 闭</el-button>
        </slot>
      </template>-->
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        AttendanceDtsId: 0,
        Remark: "",
        HandleType: "病假",
        HandleStatus: 0
      },
      tip1: "",
      tip2: "",
      now: -1,
      // leave: {
      //   LeaveId: 0,
      //   SectionId: 0,
      //   StudentId: null,
      //   FullName: "",
      //   TeacherId: null,
      //   TermId: null,
      //   StartSectionId: null,
      //   EndSectionId: null,
      //   StartDate: "",
      //   EndDate: "",
      //   ClassId: null,
      //   GradeId: null,
      // },
      typeList: ["病假","事假","公假","校内其他","走读","校本课程","医务室","心理站","迟到","无故缺勤"],
      isEdit: false,
      current: null,
      api: require("@/api/st/attendance").default,
      isMB: this.$store.state.isMB,
      termList: [],
      handeled: true,
      rules: {
        // HandleType: [{ required: true, message: "请选择处理结果" }],
        Remark: [{ required: true, message: "请填写备注/具体情况" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened() {},
    onEditOpened(data) {
      this.now = this.position()
      if(this.now > 5) {
        this.tip2 = data.Remark;
      } else {
        this.tip1 = data.Remark;
      }
    },
    typeChange() {
      this.now = this.position();
      if(this.now > 5) {
        this.tip1 = "";
      } else {
        this.tip2 = "";
      }
    },
    position() {
      var tl = this.typeList;
      return tl.indexOf(this.data.HandleType);
    },
    onBeforeSave() {
      // if(!this.data.HandleType) {
      //   this.$message.warning("请选择处理类型");
      //   return false;
      // }
      var p = this.position();
      if(p == -1) {
        this.$message.warning("请选择处理类型");
        return false;
      } else if(p < 6) {
        if(!this.tip1) {
          this.$message.warning("请填写备注");
          return false;
        } else {
          this.data.Remark = this.tip1;
        }
      } else {
        if(!this.tip2) {
          this.$message.warning("请填写具体情况");
          return false;
        } else {
          this.data.Remark = this.tip2;
        }
      }
      return true;
    },
    onClosed() {
      this.now = -1;
      this.data.HandleType = null;
      this.data.Remark = "";
      this.tip1 = "";
      this.tip2 = "";
    },
  },
};
</script>
<style lang="scss">
.el-radio{
  line-height: 30px;
}
</style>